import styled from '@emotion/styled';
import type { ChangeEvent, FunctionComponent } from 'react';

import { Loader } from './Loader';

const TextAreaContainer = styled.div({
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    background: '#f6f6f7',
    borderRadius: '0.75rem',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: "'FT Regola Neue'",
    gap: '0.5rem',
    padding: '0.75rem 0.875rem',
});

const Title = styled.h6({
    color: '#6e6e6c',
    fontFeatureSettings: "'ss03' on",
    fontSize: '0.8125rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '1rem',
    margin: 0,
});

const Description = styled.textarea({
    background: 'transparent',
    border: 'none',
    color: '#040f16',
    fontFamily: "'FT Regola Neue'",
    fontFeatureSettings: "'ss03' on",
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 400,
    height: '100%',
    letterSpacing: '-0.00875rem',
    lineHeight: '1.375rem',
    margin: 0,
    outline: 'none',
    padding: 0,
    resize: 'none',
    width: '100%',
});

type TextAreaProps = {
    readonly isGenerating?: boolean;
    readonly onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    readonly text: string;
    readonly title: string;
};

export const TextArea: FunctionComponent<TextAreaProps> = ({ isGenerating = false, onChange, text, title }) => {
    if (isGenerating) {
        return <Loader />;
    }

    return (
        <TextAreaContainer>
            <Title>{title}</Title>
            <Description value={text} onChange={onChange} />
        </TextAreaContainer>
    );
};
